var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPlay10 = function SvgIconPlay10(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71 69"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2B328C",
    d: "M7.031 13.666 0 44.374 19.701 69h31.598L71 44.374l-7.031-30.708L35.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999DC8",
    d: "M31 44V29l14 7.5z"
  }))));
};
export default SvgIconPlay10;